import React, { useState, useEffect } from 'react';
import { TextField } from '@rmwc/textfield';
import '@rmwc/textfield/styles';
import { RCTooltip } from '@rmwc/rc-tooltip';
import '@rmwc/rc-tooltip/styles';
import ResetM from './ResetM';
import { useFlexionStore } from '../Stores';
import { getText } from '../Helpers';

import './MInput.css';

function MInput() {
  const Sprache = useFlexionStore((state) => state.Sprache);
  const Länge = useFlexionStore((state) => state.Länge);
  const setLänge = useFlexionStore((state) => state.setLänge);
  const ErsterPunktDistanz = useFlexionStore((state) => state.ErsterPunktDistanz);
  const setErsterPunktDistanz = useFlexionStore((state) => state.setErsterPunktDistanz);
  const ErsterPunktLast = useFlexionStore((state) => state.ErsterPunktLast);
  const setErsterPunktLast = useFlexionStore((state) => state.setErsterPunktLast);
  const ZweiterPunktDistanz = useFlexionStore((state) => state.ZweiterPunktDistanz);
  const setZweiterPunktDistanz = useFlexionStore((state) => state.setZweiterPunktDistanz);
  const ZweiterPunktLast = useFlexionStore((state) => state.ZweiterPunktLast);
  const setZweiterPunktLast = useFlexionStore((state) => state.setZweiterPunktLast);
  const DritterPunktDistanz = useFlexionStore((state) => state.DritterPunktDistanz);
  const setDritterPunktDistanz = useFlexionStore((state) => state.setDritterPunktDistanz);
  const DritterPunktLast = useFlexionStore((state) => state.DritterPunktLast);
  const setDritterPunktLast = useFlexionStore((state) => state.setDritterPunktLast);

  const [X1Open, setX1Open] = useState(false);
  const [X2Open, setX2Open] = useState(false);
  const [X3Open, setX3Open] = useState(false);
  const [text, settext] = useState(getText(Sprache));

  useEffect(() => {
    if (parseFloat(ErsterPunktDistanz, 10) > Länge || parseFloat(ErsterPunktDistanz, 10) < 0) {
      setX1Open(true);
    } else {
      setX1Open(false);
    }

    if (parseFloat(ZweiterPunktDistanz, 10) > Länge || parseFloat(ZweiterPunktDistanz, 10) < 0) {
      setX2Open(true);
    } else {
      setX2Open(false);
    }

    if (parseFloat(DritterPunktDistanz, 10) > Länge || parseFloat(DritterPunktDistanz, 10) < 0) {
      setX3Open(true);
    } else {
      setX3Open(false);
    }
  }, [DritterPunktDistanz, ErsterPunktDistanz, Länge, ZweiterPunktDistanz]);

  function handleLänge(e) {
    if (e.target.value > 99999) {
      setLänge(Länge);
      return;
    }
    setLänge(e.target.value);
  }

  useEffect(() => {
    settext(getText(Sprache));
  }, [Sprache]);

  function getErrorText(lessThan0, error) {
    if (lessThan0 < 0) return text.MInput.LessThan0Tooltip;
    return error;
  }

  return (
    <>
      <div className='InputContainer'>
        <h4>{text.MInput ? text.MInput.TLength : ''}</h4>
        <RCTooltip
          open={parseFloat(Länge, 10) < 0}
          showArrow
          align='bottom'
          content={text.MInput.LessThan0Tooltip}
        >
          <TextField
            label={text.MInput ? text.MInput.LInput : ''}
            type='number'
            value={Länge}
            onChange={handleLänge}
            onFocus={(e) => {
              e.target.select();
            }}
            className='Input'
          />
        </RCTooltip>
        <div className='ResetM'>
          <ResetM />
        </div>
        <h4>{text.MInput ? text.MInput.FirstPoint : ''}</h4>
        <RCTooltip
          open={X1Open}
          showArrow
          content={
            <div className='ErrorTooltip'>
              {getErrorText(ErsterPunktDistanz, text.MInput.FirstError)}
            </div>
          }
        >
          <TextField
            label='X1 (mm)'
            type='number'
            value={ErsterPunktDistanz}
            onChange={(e) => {
              setErsterPunktDistanz(e.target.value);
            }}
            onFocus={(e) => {
              e.target.select();
            }}
            className='Input'
          />
        </RCTooltip>
        <RCTooltip
          open={parseFloat(ErsterPunktLast, 10) < 0}
          showArrow
          align='bottom'
          content={text.MInput.LessThan0Tooltip}
        >
          <TextField
            label={text.MInput ? text.MInput.FirstPointLoad : ''}
            type='number'
            value={ErsterPunktLast}
            onChange={(e) => setErsterPunktLast(e.target.value)}
            onFocus={(e) => {
              e.target.select();
            }}
            className='Input'
          />
        </RCTooltip>
        <h4>{text.MInput ? text.MInput.SecondPoint : ''}</h4>
        <RCTooltip
          open={X2Open}
          showArrow
          content={
            <div className='ErrorTooltip'>
              {getErrorText(ZweiterPunktDistanz, text.MInput.SecondError)}
            </div>
          }
        >
          <TextField
            label='X2 (mm)'
            type='number'
            value={ZweiterPunktDistanz}
            onChange={(e) => {
              setZweiterPunktDistanz(e.target.value);
            }}
            onFocus={(e) => {
              e.target.select();
            }}
            className='Input'
          />
        </RCTooltip>
        <RCTooltip
          open={parseFloat(ZweiterPunktLast, 10) < 0}
          showArrow
          align='bottom'
          content={text.MInput.LessThan0Tooltip}
        >
          <TextField
            label={text.MInput ? text.MInput.SecondPointLoad : ''}
            type='number'
            value={ZweiterPunktLast}
            onChange={(e) => setZweiterPunktLast(e.target.value)}
            onFocus={(e) => {
              e.target.select();
            }}
            className='Input'
          />
        </RCTooltip>

        <h4>{text.MInput ? text.MInput.ThirdPoint : ''}</h4>
        <RCTooltip
          open={X3Open}
          showArrow
          content={
            <div className='ErrorTooltip'>
              {getErrorText(DritterPunktDistanz, text.MInput.ThirdError)}
            </div>
          }
        >
          <TextField
            label='X3 (mm)'
            type='number'
            value={DritterPunktDistanz}
            onChange={(e) => {
              setDritterPunktDistanz(e.target.value);
            }}
            onFocus={(e) => {
              e.target.select();
            }}
            className='Input'
          />
        </RCTooltip>
        <RCTooltip
          open={parseFloat(DritterPunktLast, 10) < 0}
          showArrow
          align='bottom'
          content={text.MInput.LessThan0Tooltip}
        >
          <TextField
            label={text.MInput ? text.MInput.ThirdPointLoad : ''}
            type='number'
            value={DritterPunktLast}
            onChange={(e) => setDritterPunktLast(e.target.value)}
            onFocus={(e) => {
              e.target.select();
            }}
            className='Input'
          />
        </RCTooltip>
      </div>
    </>
  );
}

export default MInput;
